import $ from 'jquery';
import { InventorySearchEvents } from '@dealersites/inventory/events';
import { replaceUrlParam } from '../utilities.js';

$('#loader').hide();

$('.js-price-btn').on('change', function () {
  if ($(this).prop('checked')) {
    const id = $(this).attr('id');
    const max = $(this).val();
    const url = window.location.href;
    let newUrl = replaceUrlParam(url, 'dsp_price_min', 0);
    newUrl = replaceUrlParam(newUrl, 'dsp_price_max', max);
    newUrl = replaceUrlParam(newUrl, 'price_btn', id);
    window.location.assign(newUrl);
  }
});

$('.js-price-input').on('change', function () {
  const value = $(this).val();
  if (parseInt(value)) {
    const param = $(this).data('param');
    const url = window.location.href;
    let newUrl = replaceUrlParam(url, param, value);
    newUrl = replaceUrlParam(newUrl, 'price_input', true);
    newUrl = replaceUrlParam(newUrl, 'price_btn', 0);
    window.location.assign(newUrl);
  }
});

$(document).on(InventorySearchEvents.PRE_FETCH, (e) => {
  $('.filter-counts').each(function() {
    $(this).addClass('loading');
  });
});

$(document).on(InventorySearchEvents.POST_RENDER, (e, vehicleContainer) => {
  const resultsCounts = $(vehicleContainer).find('.vehicle-results-counts');
  const count = resultsCounts.attr('data-count');
  const total = resultsCounts.attr('data-total');
  $('.filter-counts').each(function() {
    $(this).find('.count').text(count);
    $(this).find('.total').text(total);
    $(this).removeClass('loading');
  });
});

